import React, { useEffect, useRef, useState } from 'react'
import { useIsWinnerDeclared, useWinningPotDisplay, usePlayerData } from './useGameTable';

export default function useWinningHand(tempTableId) {
	const isWinnerDeclared = useIsWinnerDeclared(tempTableId);
	const winningPotDisplay = useWinningPotDisplay(tempTableId);
	const playerData = usePlayerData(tempTableId);
	const [winningHand, setWinningHand] = useState([]);

	useEffect(() => {
		if (isWinnerDeclared && winningPotDisplay) {
			getWinningHandCards();
		} else {
			setWinningHand([]);
		}
	}, [isWinnerDeclared, winningPotDisplay]);

	const getWinningHandCards = () => {
		if (winningPotDisplay) {
			let allWinningCards = [];
			// Iterate through all winner names
			winningPotDisplay.winnerNames.forEach(winnerName => {
				let winningPlayer = playerData?.find(
					(player) => player.userName === winnerName
				);
				if (winningPlayer?.winningHand) {
					// Add all cards from this winner to the array
					allWinningCards = [...allWinningCards, ...winningPlayer.winningHand];
				}
			});
			setWinningHand(allWinningCards);
		}
	};

	return winningHand || []
}
